import { ucfirst } from '@df/util/fn/ucfirst.fn';
import { NICmsContentField } from '@icms/core/content';
import { EModelCarouselVariant, IModelCarouselData } from './model-carousel.interface';

export function getFields(type: 'product' | string, qty = 36, pageType?: string): NICmsContentField.IField[] {
    let loadFilter;

    if (pageType) {
        loadFilter = { pageType };
    }

    return [
        // header
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'section-header',
            title: 'Header'
        },
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title'
        },
        // content
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'section-content',
            title: 'Content'
        },
        <NICmsContentField.IChoiceField>{
            key: 'variant',
            required: true,
            type: NICmsContentField.EFieldType.choice,
            title: 'Source type',
            options: [
                {
                    key: EModelCarouselVariant.ModelsIds,
                    title: ucfirst(type.split('-').join(' ')) + ' selection'
                },
                type === 'product'
                    ? {
                          key: EModelCarouselVariant.CategoryProducts,
                          title: 'Category Selection'
                      }
                    : undefined
            ].filter(i => !!i),
            default: type === 'product' ? EModelCarouselVariant.CategoryProducts : EModelCarouselVariant.ModelsIds
        },
        <NICmsContentField.IRelationField>{
            key: 'category_id',
            type: NICmsContentField.EFieldType.relation,
            title: 'Category',
            options: {
                title: 'Category',
                type: 'category',
                qty: 1
            },
            canShow: (data: IModelCarouselData) => data?.variant === EModelCarouselVariant.CategoryProducts
        },
        <NICmsContentField.INumberField<number>>{
            key: 'limit',
            type: NICmsContentField.EFieldType.number,
            title: 'Items Limit',
            description: 'Max number of items that can be displayed',
            helper: 'Max limit is ' + qty,
            min: 1,
            max: qty,
            step: 1,
            default: qty,
            sanitize: (input: number) => {
                const value = Math.max(1, Math.min(input, qty));

                if (input < 1) {
                    return {
                        error: 'Limit cannot be less than 1',
                        value
                    };
                } else if (input > qty) {
                    return {
                        error: 'Limit cannot be more than ' + qty,
                        value
                    };
                }

                return value;
            },
            canShow: (data: IModelCarouselData) => data?.variant === EModelCarouselVariant.CategoryProducts
        },
        <NICmsContentField.IRelationField>{
            key: 'ids',
            type: NICmsContentField.EFieldType.relation,
            title: 'Items',
            options: {
                title: ucfirst(type.split('-').join(' ')),
                type,
                multiple: true,
                qty,
                loadFilter
            },
            multiple: true,
            canShow: (data: IModelCarouselData) => data?.variant === EModelCarouselVariant.ModelsIds
        }
    ];
}
